import { jsxs, jsx } from 'react/jsx-runtime';
import { useBrowser } from '@circlefin/hooks';
import classNames from 'classnames';
import variants from './variants/index.es.js';

const Chiclets = ({ variant, size, rotate = 0, blur = 0, opacity = 1, className, ...props })=>{
    const { browser } = useBrowser();
    const classes = classNames('cb-chiclets', `cb-chiclets-${variant}`, className);
    /**
     * Style control
     * (It can also be done with SVG filter, but will not overflow outside).
     *
     * There are a couple of workarounds here:
     * 1. Safari does not support `filter: blur()` on nested SVGs and so we apply that
     * on the parent SVG instead.
     *
     * 2. Firefox seems to have a different measurement for `filter: blur()` and so
     * we need to adjust the blur px.
     */ const style = {
        opacity
    };
    // Skip blur on Safari
    if (!browser?.isSafari) {
        // multiple blur by 10 for Firefox and keep it as is for Chrome
        style.filter = `blur(${browser?.isFirefox ? blur * 10 : blur}px)`;
    }
    /**
     * Construct LinearGradient from the stop colors.
     */ function LinearGradient() {
        const color = variants[variant];
        return jsx("linearGradient", {
            "data-testid": "linear-gradient",
            id: variant,
            spreadMethod: "reflect",
            children: color.map(({ stopColor, offset }, k)=>jsx("stop", {
                    offset: `${offset}%`,
                    stopColor: stopColor
                }, `${variant}${k}-lg`))
        });
    }
    return jsxs("svg", {
        className: classes,
        height: size,
        preserveAspectRatio: "xMinYMid meet",
        style: style,
        viewBox: "0 0 100 100",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        "data-testid": "chiclets",
        children: [
            jsxs("title", {
                children: [
                    variant,
                    " chiclets"
                ]
            }),
            jsx("defs", {
                children: jsx(LinearGradient, {})
            }),
            jsx("circle", {
                cx: "50%",
                cy: "50%",
                "data-testid": "circle",
                fill: `url(#${variant})`,
                id: `chiclets/${variant}`,
                r: "50%",
                transform: `translate(50, 50) rotate(${rotate}) translate(-50, -50)`
            })
        ]
    });
};
Chiclets.displayName = 'Chiclets';

export { Chiclets, Chiclets as default };
//# sourceMappingURL=Chiclets.es.js.map
